import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import {
    SuccessfulSubtitleContainer,
    SuccessfulTextContainer,
    SuccessIconCheck,
    SuccessIconContainer,
} from "../../SwitchPackageStage.styled";

export const StageSuccessIcon = () => (
    <SuccessIconContainer>
        <SuccessIconCheck
            size="xxl"
            color={colorsPalettes.carbon[0]}
        />
    </SuccessIconContainer>
);

export const StageSuccessDescription = () => {
    const { translate } = useTranslate();
    return (
        <SuccessfulTextContainer>
            <Text
                fontVariant="h4"
                color={colorsPalettes.carbon[500]}
            >
                {translate("buyer_journey.purchase.success.title.v2")}
            </Text>
            <SuccessfulSubtitleContainer>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("buyer_journey.purchase.success.subtitle.1")}
                </Text>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("buyer_journey.purchase.success.subtitle.2")}
                </Text>
            </SuccessfulSubtitleContainer>
        </SuccessfulTextContainer>
    );
};
